// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"7863d6db","228":"46c13576","537":"5c7f5171","880":"c0ba4c08"}[chunkId] + ".chunk.css";
};